
export const environment = {
    production: false,
    authApiUrl: 'https://dev.epathware.com/user-management',
    apiURL: 'https://dev.epathware.com/user-management',
    epwUrl: 'https://app.epathware.com/epw-core',
    epw: 'https://app.epathware.com/',
    baseUrl: 'https://dev.x.epathware.com',
    filesApiUrl: 'https://dev.epathware.com/gcs',
    cdnUrl: 'https://dev.epathware.com/gcs',
    recaptchaKey: '6Lf8wgEgAAAAAHly0j9e51Uzi6dZ5PvyqDw9O9PB',
    placesApiKey: 'AIzaSyBaKgb5XgCiSjaPg0p3-IRChjjCyE94LQY'
};
